// The one app font (Geist Sans, self-hosted via @fontsource in index.js).
// CSS uses the same stack through `var(--app-font)` (App.scss). Use this in
// JS styles (MUI theme, JSS, charts) instead of naming fonts again.
const APP_FONT = '"Geist Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

export default APP_FONT;
